
<!-- <div id="bar-chart" style="width: 100%; height: 400px;"></div> -->
 <!-- [push asset code] -->
<ion-content class="container">
  <div class="tabs-container">
    <div class="card">
      <ion-row *ngIf="!router.url.includes('Setup')">
        <ion-col size-sm="10" size-md="9" size-lg="9" size-xs="10" class="pl-15 pr-0 pb-0">
          <div class="borderbottomForTab" *ngIf="!router.url.includes('Setup') ">
            <mat-tab-group #tabGroup class="pt-10 pr-10" [selectedIndex]="selectedTypeTabIndex"
              (selectedTabChange)="tabTypeChanged($event)" *ngIf="(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin')||findLogdinUserAsaAuthority"
              >
              <!-- *ngIf= "!(loggedInUserRole == 'Employee')|| findLogdinUserAsaAuthority" -->
              <mat-tab label="Dashboard">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      speed
                    </span>Dashboard</span>
                </ng-template>
              </mat-tab>
              <mat-tab label="Asset"
                *ngIf="!(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin')">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      person
                    </span>My Asset</span>
                </ng-template>
              </mat-tab>
              <mat-tab label="Inventory" *ngIf="!(loggedInUserRole == 'HR Admin') && findLogdinUserAsaAuthority">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      ads_click
                    </span>My Dept Inventory </span>
                </ng-template>
              </mat-tab>
              <mat-tab label="Laptop" *ngIf=" (loggedInUserRole == 'HR Admin')  ">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      ads_click
                    </span>Company Inventory</span>
                </ng-template>
              </mat-tab>
              <mat-tab label="Reports">
                <ng-template mat-tab-label>
                  <span style="display: contents;">
                    <span class="material-icons mr-10">
                      description
                    </span>Reports</span>
                </ng-template>
              </mat-tab>
            </mat-tab-group>


            <mat-tab-group #tabGroup class="pt-10 pr-10" [selectedIndex]="selectedTypeTabIndex"
            (selectedTabChange)="tabTypeChanged($event)" *ngIf="loggedInUserRole=='Employee'&& !findLogdinUserAsaAuthority"
            >
            <!-- *ngIf= "!(loggedInUserRole == 'Employee')|| findLogdinUserAsaAuthority" -->
           
            <mat-tab label="Asset"
              *ngIf="!(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'||findLogdinUserAsaAuthority)">
              <ng-template mat-tab-label>
                <span style="display: contents;">
                  <span class="material-icons mr-10">
                    person
                  </span>My Asset</span>
              </ng-template>
            </mat-tab>
            
            <mat-tab label="Reports">
              <ng-template mat-tab-label>
                <span style="display: contents;">
                  <span class="material-icons mr-10">
                    description
                  </span>Reports</span>
              </ng-template>
            </mat-tab>
          </mat-tab-group>


          </div>
        </ion-col>
        <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="" class="borderbottomForTab pl-10 pt-10 pr-10"
          *ngIf="!router.url.includes('Setup')  && (loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin' || loggedInUserRole == 'MD')">
          <div class="center-content float-right">
            <div>
              <span class="cp fs-14 link font_regular center-content mr-20" (click)="onClickLogs('Logs')">
                <img src="././assets/icon/logsIcon.svg"><u>Logs</u></span>
            </div>
            <div>
              <button type="button" class="add_btn fs-14 float-right center-content mr-5"
                [style.background-color]="buttonColorName" (click)="onClickSetup('Setup')">
                <span class="material-icons fs-20 mr-5">settings</span>Setup</button>




            </div>
          </div>
        </ion-col>
      </ion-row>

    </div>
    <!---Setup Popup --->



    <div class="modal fade" [style.display]="showSetupPopup ? 'block' : 'none'">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="mt-10 d-flex pt-5 pb-10 pr-10 pl-0 headerBreadcrumb" (click)="onClickback()">
            <img src="././assets/icon/backArrow.svg" class="cp">
            <label class="font_semibold fs-18 ml-10 mt-5 black_color" >
              <span class="cp">Asset</span> /
              <span [style.color]="buttonColorName">Setup</span>
            </label>
          </div>
          <div class="modal-body p-20">
            <div class="mt-10">
              <div class="cardBox card" style="background-color: white; padding: 10px;">
                <ion-row>
                  <ion-col size="4" class="mt-10">
                    <div class="formLabelRegularfs16 mb-5">
                      Fiscal Year<span class="red-cl">&nbsp;*</span>
                    </div>
                    <div class="inputBoxDisabled">
                      {{ sharedService.transform(loggedInCompanyFiscalyear) }}
                    </div>
                  </ion-col>
                  <ion-col size="4" class="mt-10">
                    <div class="formLabelRegularfs16 mb-5">
                      Year<span class="red-cl">&nbsp;*</span>
                    </div>
                    <mat-form-field class="w-100 mat-height40 mat-input-style">
                      <mat-select placeholder="Select" [(ngModel)]="selectedYearForCompetency"
                        (selectionChange)="getYearSetupForReimbursement()">
                        <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                          {{sharedService.transformYearToFyFormat(item.year)}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ion-col>

                </ion-row>
                <ion-row>
                </ion-row>



              </div>
            </div>

          </div>
          <!-- Allocating DepartMent -->
          <div class="modal-body p-10">
            <div class="mt-2">
              <div class="cardBox card">

                <div class="card  employeeTab">
                  <div class="card-body">
                    <div>

                      <div class="p-10">
                        <button type="button" class="add_btn fs-14 mr-15"
                          style="display: flex;float: right; margin-bottom:10px; align-items: center"
                          [style.background-color]="buttonColorName" (click)="addAuthority(null)">
                          + New Authority</button>
                        <div class="table-container">

                          <table class="custom-table rounded-header">

                            <thead>
                              <tr>

                                <th *ngFor="let item of  allocatingDepaabaleheader; let rowId=index;"
                                  class="fs-14 font_bold cl-black">
                                  <div class=" verticle-center justify-content-space-between icon-style">
                                    {{ item?.label }}

                                    <div class="d-flex flex-column ml-10">
                                      <i  (click)="onSortAssending(item.sortingName)"
                                        class="material-icons materialIconsHeight cp">arrow_drop_up</i>
                                      <i (click)="onSortDesending(item.sortingName)"
                                        class="material-icons materialIconsHeight cp">arrow_drop_down</i>
                                    </div>
                                  </div>
                                </th>

                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let row of autorityListData; let rowId=index;">
                                <td>{{row.assetDepartmentName}}</td>
                                <td>{{row.employeeName}}</td>

                                <!-- <td>Edit/Delete</td> -->
                                <td>
                                  <img class="mr-5 cp imgdelete" title="Edit" src="././assets/icon/edit.png"
                                    (click)="addAuthority(row)" width="25px">

                                  <span class="material-icons fs-20 red cp"
                                    (click)="deleteAuthority(row.assetAuthorityId)">delete</span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="mt-10" style="font-weight: bold;">
                          {{autorityListData.length}} entries
                        </div>
                      </div>
                    </div>
                  </div>
                </div> 

              </div>
            </div>

          </div>

          <!-- set Asset -->

          <div class="modal-body p-10">
            <div class="mt-10">
              <div class="cardBox card">

                <div class="card  employeeTab assetTable">
                  <div class="card-body">
                    <div>

                      <div class="p-10">
                        <button type="button" class="add_btn fs-14 mr-15"
                          style="display: flex;float: right; margin-bottom:10px; align-items: center"
                          [style.background-color]="buttonColorName" (click)="addAsset(null)">
                          + New Asset</button>
                        <div class="table-container">

                          <table class="custom-table rounded-header">

                            <thead>
                              <tr>

                                <th *ngFor="let item of  assettabaleheader" class="fs-14 font_bold cl-black">
                                  <div class=" verticle-center justify-content-space-between icon-style">
                                    {{ item?.label }}

                                    <div class="d-flex flex-column ml-10">
                                      <i (click)="onSortAssendingForAsset(item.sortingName)"
                                        class="material-icons materialIconsHeight cp">arrow_drop_up</i>
                                      <i (click)="onSortDesendingForasset(item.sortingName)"
                                        class="material-icons materialIconsHeight cp">arrow_drop_down</i>
                                    </div>
                                  </div>
                                </th>

                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let row of  AllAssetListingData">
                                <td (click)="showAsset(row.assetId)"
                                  style="cursor: pointer !important;  color: #143E8E;">{{row.assetName}}</td>
                                <td>{{row.bands}}</td>
                                <td>{{row.authorityDepartment}}</td>
                                <td>{{row.authorityName}}</td>
                                <td>


                                  <img class="mr-5 cp imgdelete" title="Edit" src="././assets/icon/edit.png"
                                    (click)="addAsset(row)" width="25px">
                                  <span class="material-icons fs-20 red cp"
                                    (click)="deleteAasset(row.assetId)">delete</span>
                                </td>

                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="mt-10" style="font-weight: bold;">
                          {{AllAssetListingData.length}} entries
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <ion-row>
                </ion-row>
                <ion-row>

                </ion-row>
              </div>
            </div>

          </div>
        </div>
      </div>


    </div>


    <!-- --------------------------------------------------------Assign Laptop To Employee ------------------------------------------------------------------------>

    <div *ngIf="selectedTypeTabName=='Laptop' " style="margin: 20px !important;">

      <ion-col size-sm="3" size-md="3" size-lg="3" size-xs="3">
        <mat-form-field class="mat-height40 mat-input-style" style="margin-left: 20px;">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="search" placeholder="Search"  [(ngModel)]="searchTerm" (input)="filterAssets(searchTerm);">
            <!-- <input [(ngModel)]="searchTerm" type="text" placeholder="Search Users" class="form-control mb-3" /> -->
  
        </mat-form-field>
      </ion-col>
      <div style="margin-bottom: 15px;">
      
        <button type="button" class="add_btn fs-14 mr-15"
          style="display: flex;float: right; margin-bottom:10px; align-items: center"
          [style.background-color]="buttonColorName" (click)="userAsset(null)">
          + New Asset</button>

          <button type="button" class="add_btn" style="float: right; margin-bottom: 10px; align-items: center;"
          [style.background-color]="buttonColorName" (click)="addNewAssetEmployee(null)">
          + New Joiner Employee
        </button>
      </div>
      <div class="mt-10 table-bordered laptopAllocation" style="clear: both;">
        <app-reusable-table [parentHeaders]="parentHeaders" [nestedHeaders]="nestedHeaders" [tableData]="assets" [selectedTabName]="selectedTypeTabName"
          nestedKey="users" (onAssetNameClick)="userAsset($event)" expandKey="isExpand"(deleteEmployee)="deleteasset($event)" (onAssetNameClickInside)="employeeAsset($event)">
        </app-reusable-table>
      </div>
      <!--   (onAssetNameClickInside)="employeeAsset($event)" -->
    </div>
    <!----------------------------------------------------------------------- InVentory For Specific Authority------------------------------------------------------------------------------------- -->
    <div *ngIf="selectedTypeTabName == 'Inventory'" style="margin: 20px !important;">
      <!-- Row for Add New Asset Button -->
      <div style="margin-bottom: 15px;">
        <button type="button" class="add_btn" style="float: right; margin-bottom: 10px; align-items: center;"
          [style.background-color]="buttonColorName" (click)="allocateAuthority(null)">
          + New Asset
        </button>
        <button type="button" class="add_btn" style="float: right; margin-bottom: 10px; align-items: center;"
          [style.background-color]="buttonColorName" (click)="addNewAssetEmployee(null)">
          + New Joiner Employee
        </button>
      </div>

      <!-- Row for Table View -->
      <div class="mt-10 table-bordered laptopAllocation" style="clear: both;">
        <app-reusable-table [parentHeaders]="parentHeaders" [nestedHeaders]="nestedHeaders"  [selectedTabName]="selectedTypeTabName"
          [tableData]="allocatingAsset" nestedKey="users" (onAssetNameClick)="allocateAuthority($event)"(deleteEmployee)="deleteasset($event)" 
          expandKey="isExpand"  (onAssetNameClickInside)="employeeAsset($event)">
        </app-reusable-table>
      </div>
    </div>
    <!--    (onAssetNameClickInside)="employeeAsset($event)" -->

    <!-- ----------------------------------------------------------------------------- MY Asset------------------------------------------------------------- -->
    <div *ngIf="selectedTypeTabName=='Asset'||loggedInUserRole=='Employee'&& !findLogdinUserAsaAuthority" style="margin: 20px !important;">
      <div class="mt-10 table-bordered laptopAllocation" style="clear: both;" *ngIf="selectedTypeTabName!=='Reports'">
        <app-reusable-table [parentHeaders]="parentHeadersForEmployee" [nestedHeaders]="nestedHeadersForEmployee"
          [tableData]="allocatingEmployee" nestedKey="users" (onAssetNameClickInside)="employeeAsset($event)"
          expandKey="isExpand" [selectedTabName]="selectedTypeTabName">
        </app-reusable-table>
      </div>
      <!--  (onAssetNameClick)="allocateAuthority($event)" -->






    </div>


    <div *ngIf="selectedTypeTabName=='Reports'" style="margin: 20px !important;">
    
        <app-asset-management-report></app-asset-management-report>

    </div>

    <div *ngIf="(loggedInUserRole == 'HR Admin' || loggedInUserRole == 'Super Admin' || loggedInUserRole == 'PHI Admin'
     || loggedInUserRole == 'MD')||(loggedInUserRole=='Employee'&& findLogdinUserAsaAuthority)||(loggedInUserRole=='Manager'&& findLogdinUserAsaAuthority) &&!router.url.includes('Setup') " style="margin: 20px !important;">
    <div *ngIf="selectedTypeTabName=='Dashboard'&&!router.url.includes('Setup')">


      <app-asset-dashboard></app-asset-dashboard>
    </div>

  </div>
  </div>
</ion-content>